import {NamedStyles, StyleHelper} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';
import {stylePatterns} from '../../theme/patterns';
import {AccordionVariant} from './model';

export const createStyles = (
  {theme, mediaOnly, isDesktop}: StyleHelper,
  variant: AccordionVariant,
): NamedStyles<any> => ({
  wrap:
    variant === 'filled'
      ? {
          overflow: 'hidden',
          borderRadius: isDesktop ? 40 : 24,
          ...theme.accordion.itemFilledBoxShadow,
          marginBottom: isDesktop ? 30 : 20,
        }
      : {
          paddingHorizontal: isDesktop ? 32 : 19,
          borderBottomWidth: 1,
          borderColor: theme.accordion.itemOutlinedBorderColor,
        },
  header:
    variant === 'filled'
      ? {
          position: 'relative',
          height: isDesktop ? 77 : 63,
          width: '100%',
          backgroundColor: theme.accordion.headerBgColor,
          paddingHorizontal: isDesktop ? 33 : 19,
          paddingVertical: 10,
          ...stylePatterns.flexCenterVertical,
        }
      : {
          ...stylePatterns.flexCenterVertical,
          paddingVertical: isDesktop ? 23 : 18,
        },
  touchableHeaderZone: {
    zIndex: 1,
  },
  headerText:
    variant === 'filled'
      ? {
          ...mediaOnly(DeviceSize.desktop, theme.fonts.h3, theme.fonts.action),
          color: theme.accordion.headerTextColor,
          // paddingRight: isDesktop ? 100 : 35,
        }
      : {
          ...mediaOnly(DeviceSize.desktop, theme.fonts.h4Light, theme.fonts.body),
        },
  content: {
    backgroundColor: theme.accordion.itemContentBgColor,
    ...mediaOnly(
      DeviceSize.desktop,
      {
        paddingHorizontal: 32,
        paddingVertical: variant === 'filled' ? 26 : 0,
      },
      {
        paddingHorizontal: 19,
        paddingVertical: 22,
      },
    ),
  },
  arrow: {
    position: 'absolute',
    top: isDesktop ? 30 : 22,
    right: isDesktop ? 48 : 35,
    transform: [{rotate: '-90deg'}],
    color: theme.accordion.headerTextColor,
  },
  arrowActive: {
    transform: [{rotate: '90deg'}],
  },
  shapeWrap: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: theme.accordion.headerTextColor,
  },
});
